// ============================
// CATEGORY SCROLL - HAND TOUCH (SMOOTH)
// ============================
document.addEventListener('DOMContentLoaded', function() {
  const scrollContainer = document.getElementById('categoryScroll');
  
  if (!scrollContainer) return;
  
  // ========== MOUSE DRAG ==========
  let isDown = false;
  let startX;
  let scrollLeft;
  let momentum = 0;
  let lastMoveTime = 0;
  let lastMoveX = 0;
  
  scrollContainer.addEventListener('mousedown', (e) => {
    isDown = true;
    scrollContainer.style.cursor = 'grabbing';
    scrollContainer.style.scrollBehavior = 'auto';
    startX = e.pageX - scrollContainer.offsetLeft;
    scrollLeft = scrollContainer.scrollLeft;
    momentum = 0;
    lastMoveTime = Date.now();
    lastMoveX = e.pageX;
  });
  
  scrollContainer.addEventListener('mouseleave', () => {
    isDown = false;
    scrollContainer.style.cursor = 'grab';
    scrollContainer.style.scrollBehavior = 'smooth';
  });
  
  scrollContainer.addEventListener('mouseup', () => {
    isDown = false;
    scrollContainer.style.cursor = 'grab';
    scrollContainer.style.scrollBehavior = 'smooth';
  });
  
  scrollContainer.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - scrollContainer.offsetLeft;
    const walk = (x - startX) * .5; // Increased for smoother feel
    scrollContainer.scrollLeft = scrollLeft - walk;
    
    // Calculate momentum
    const now = Date.now();
    if (now - lastMoveTime > 20) {
      momentum = (e.pageX - lastMoveX) * 1.2;
      lastMoveTime = now;
      lastMoveX = e.pageX;
    }
  });
  
  // ========== MOMENTUM SCROLL (Flick effect) ==========
  scrollContainer.addEventListener('mouseup', () => {
    if (Math.abs(momentum) > 0.5) {
      const startScroll = scrollContainer.scrollLeft;
      const endScroll = startScroll - momentum * 8;
      const duration = 400;
      const startTime = performance.now();
      
      function animateMomentum(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        // Ease out cubic
        const ease = 1 - Math.pow(1 - progress, 3);
        const currentScroll = startScroll + (endScroll - startScroll) * ease;
        scrollContainer.scrollLeft = currentScroll;
        
        if (progress < 1) {
          requestAnimationFrame(animateMomentum);
        }
      }
      requestAnimationFrame(animateMomentum);
      momentum = 0;
    }
  });
  
  // ========== TOUCH DRAG (Mobile) ==========
  let touchStartX = 0;
  let touchScrollLeft = 0;
  let touchMomentum = 0;
  let lastTouchTime = 0;
  let lastTouchX = 0;
  
  scrollContainer.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].pageX - scrollContainer.offsetLeft;
    touchScrollLeft = scrollContainer.scrollLeft;
    scrollContainer.style.scrollBehavior = 'auto';
    touchMomentum = 0;
    lastTouchTime = Date.now();
    lastTouchX = e.touches[0].pageX;
  }, { passive: true });
  
  scrollContainer.addEventListener('touchmove', (e) => {
    const x = e.touches[0].pageX - scrollContainer.offsetLeft;
    const walk = (x - touchStartX) * 2.5;
    scrollContainer.scrollLeft = touchScrollLeft - walk;
    
    const now = Date.now();
    if (now - lastTouchTime > 20) {
      touchMomentum = (e.touches[0].pageX - lastTouchX) * 1.2;
      lastTouchTime = now;
      lastTouchX = e.touches[0].pageX;
    }
  }, { passive: true });
  
  scrollContainer.addEventListener('touchend', () => {
    scrollContainer.style.scrollBehavior = 'smooth';
    
    if (Math.abs(touchMomentum) > 0.5) {
      const startScroll = scrollContainer.scrollLeft;
      const endScroll = startScroll - touchMomentum * 8;
      const duration = 400;
      const startTime = performance.now();
      
      function animateTouchMomentum(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const ease = 1 - Math.pow(1 - progress, 3);
        const currentScroll = startScroll + (endScroll - startScroll) * ease;
        scrollContainer.scrollLeft = currentScroll;
        
        if (progress < 1) {
          requestAnimationFrame(animateTouchMomentum);
        }
      }
      requestAnimationFrame(animateTouchMomentum);
      touchMomentum = 0;
    }
  }, { passive: true });
});